export default "__VITE_ASSET__BhedkBLQ__"